const usdt = [{
    coin: 'BTC/USDT',
    vlr: 0.00020255,
    color: 'red',
    updow: '-2.58%'
},
{
    coin: 'KCS/USDT',
    vlr: 0.00013192,
    color: 'green',
    updow: '	+5.6%'

},
{
    coin: ' XRP/USDT',
    vlr: 0.00002996,
    color: 'red',
    updow: '-1.55% '

},
{
    coin: 'VET/USDT',
    vlr: 0.00000103,
    color: 'green',
    updow: '+1.8%'

},
{
    coin: ' EOS/USDT',
    vlr: 0.00000103,
    updow: '-2.05%',
    color: 'red',

},
{
    coin: ' BTT/USDT',
    vlr: 0.00002303,
    color: 'red',
    updow: '-1.05% '

},
{
    coin: 'LTC/USDT',
    vlr: 0.03520103,
    color: 'green',
    updow: '+1.5%'

},
{
    coin: ' TRX/USDT',
    vlr: 0.00330103,
    color: 'red',
    updow: '-3.05% '

}, {
    coin: 'BSV/USDT',
    vlr: 0.00300103,
    color: 'green',
    updow: '+2.05%'

}, {
    coin: 'COTI/USDT',
    vlr: 0.003500103,
    color: 'green',
    updow: '+2.85%'

}, {
    coin: ' XYT/USDT',
    color: 'green',
    vlr: 0.00003103,
    updow: '+3.55%'

}, {
    coin: ' BNB/USDT',
    vlr: 0.003500103,
    color: 'red',
    updow: '-2.05% '

}, {
    coin: 'XMR/USDT',
    vlr: 0.003500103,
    color: 'red',
    updow: '-1.05%'

}, {
    coin: ' TRY/USDT',
    vlr: 0.00000123,
    color: 'red',
    updow: '-2.05%'
}, 
]

export default usdt